import { FleetManagementRow } from "../types/FleetManagement-row.types";
import { FleetStatus } from "../types/FleetManagement.types";

export function getFleetRowBackgroundColor(
  isEditable: boolean,
  isSelected: boolean,
  row: FleetManagementRow
): string {
  if (!isEditable && isSelected) {
    return "rgba(25, 118, 210, 0.08)";
  }

  if (row.status === FleetStatus.Available) {
    return "rgba(40, 184, 105, 0.14)";
  }

  if (row.status === FleetStatus.Booked) {
    return "rgba(255, 0, 0, 0.10)";
  }

  return "rgba(210, 218, 225, 0.35)";
}
